import { useEffect } from "react";

import { ParceirosHeader } from "@/components/parceiros/ParceirosHeader";
import { ParceirosHero } from "@/components/parceiros/ParceirosHero";
import { ParceirosTrustBar } from "@/components/parceiros/ParceirosTrustBar";
import { ParceirosOferta } from "@/components/parceiros/ParceirosOferta";
import { ParceirosComoFunciona } from "@/components/parceiros/ParceirosComoFunciona";
import { ParceirosSobreAllu } from "@/components/parceiros/ParceirosSobreAllu";
import { ParceirosFAQ } from "@/components/parceiros/ParceirosFAQ";
import { ParceirosStickyCTA } from "@/components/parceiros/ParceirosStickyCTA";
import { ParceirosFooter } from "@/components/parceiros/ParceirosFooter";
import { SelecaoDepoimentosAssessor } from "@/components/selecao/SelecaoDepoimentosAssessor";
import { SelecaoDepoimentosInvestidor } from "@/components/selecao/SelecaoDepoimentosInvestidor";
import { useMetaPixel } from "@/hooks/useMetaPixel";

const PAGE_TITLE = "Programa de Parceiros — Allu Invest";
const PAGE_DESC =
  "Divulgue para os seus clientes um produto privado lastreado em operação real. Programa de parceiros da Allu Invest para assessores certificados com carteira ativa.";

const Parceiros = () => {
  useMetaPixel();

  useEffect(() => {
    const prevTitle = document.title;
    document.title = PAGE_TITLE;

    const metaDesc = document.querySelector('meta[name="description"]');
    const prevDesc = metaDesc?.getAttribute("content") ?? "";
    metaDesc?.setAttribute("content", PAGE_DESC);

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    return () => {
      document.title = prevTitle;
      metaDesc?.setAttribute("content", prevDesc);
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = "";
      document.body.style.fontFamily = prevBodyFont;
    };
  }, []);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#323F4F]"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <ParceirosHeader />
      <main>
        <ParceirosHero />
        <SelecaoDepoimentosAssessor />
        <SelecaoDepoimentosInvestidor />
        <ParceirosTrustBar />
        <ParceirosOferta />
        <ParceirosComoFunciona />
        <ParceirosSobreAllu />
        <ParceirosFAQ />
      </main>
      <ParceirosFooter />
      <ParceirosStickyCTA />
    </div>
  );
};

export default Parceiros;
